var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6666 43.1667L31.9999 32.5M31.9999 32.5L21.3332 43.1667M31.9999 32.5V56.5M54.3732 49.54C56.9741 48.1221 59.0288 45.8784 60.2129 43.163C61.397 40.4477 61.6431 37.4153 60.9124 34.5445C60.1818 31.6737 58.5159 29.128 56.1777 27.3092C53.8395 25.4904 50.9622 24.502 47.9999 24.5H44.6399C43.8327 21.378 42.3283 18.4796 40.2398 16.0227C38.1512 13.5657 35.5328 11.6143 32.5815 10.315C29.6302 9.01565 26.4227 8.4023 23.2002 8.52103C19.9777 8.63976 16.8241 9.48748 13.9764 11.0004C11.1287 12.5134 8.66099 14.6523 6.75889 17.2562C4.85678 19.8602 3.56973 22.8614 2.99451 26.0344C2.41928 29.2073 2.57084 32.4694 3.4378 35.5754C4.30475 38.6813 5.86454 41.5503 7.9999 43.9667",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.b3d49259dae374fa785c049a525587ca.svg";
export { ForwardRef as ReactComponent };